"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Heading.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Assuming you have a corresponding stylesheet

var Heading = function Heading(_ref) {
  var _ref$level = _ref.level,
    level = _ref$level === void 0 ? 1 : _ref$level,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? "regular" : _ref$weight,
    style = _ref.style,
    children = _ref.children;
  var HeadingTag = "h".concat(level);
  var weightClass = "heading-".concat(weight);
  return /*#__PURE__*/_react["default"].createElement(HeadingTag, {
    className: weightClass,
    style: style
  }, children);
};
var _default = exports["default"] = Heading;